// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useState} from 'react';
import cn from 'classnames';
import styles from './currency_select.module.less';

export const Currency_select = props=>{
    const {currency, currencies, on_change, cls} = props;
    const [opened, set_opened] = useState(false);
    const on_toggle = ev=>{
        ev.stopPropagation();
        set_opened(!opened);
    };
    const on_select = ev=>on_change(ev.target.dataset.value);
    const cls_root = cn(styles.currency_select, opened && styles.opened,
        props.only_right_part && styles.only_right_part,
        props.float_right && styles.float_right,
        cls);
    useEffect(()=>{
        const close = ()=>{ set_opened(false); };
        window.addEventListener('click', close, true);
        return ()=>window.removeEventListener('click', close);
    }, []);
    return <div className={cls_root}>
      <div>
        <span onClick={on_toggle}>{currency}</span>
        <ul>
          {currencies.map(c=>c!=currency && <li key={c} data-value={c}
            onClick={on_select}>{c}</li>)}
        </ul>
      </div>
    </div>;
};
